export const isMigrationFlag = (purpose?: string) => purpose === 'migration';

export const isAiConfigFlag = (purpose?: string) => purpose === 'ai';
